import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ContactFormLinkFormatting } from "@faire/retailer-visitor-shared/components/Links";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { VanillaBackground, ContentContainer, MOBILE_PADDING, TABLET_PADDING } from "@faire/retailer-visitor-shared/views/about/components/common";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var ContactModuleBase = function() {
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    var isSSR = useIsSSR();
    var image = useResponsiveValue({
        mobileAndAbove: {
            src: "https://cdn.faire.com/fastly/a39d7efcadf0223fd85fbed72ef71e80984c46b615f841c72df705a2901c19fa.png",
            alt: "Picture of a Fancy Marble Table with Serveware",
            height: 429
        },
        tabletAndAbove: {
            src: "https://cdn.faire.com/fastly/dc043896025c622af014e435f40cdb95cc7d14ddb457088bc8ed798e96c88aed.png",
            alt: "Picture of a Fancy Marble Table with Serveware",
            height: 429
        },
        desktopAndAbove: {
            src: "https://cdn.faire.com/fastly/63ba5639f462861334acb6550f8c1a42a23a3a531be8c7c8fc9efbb3f9645e7b.png",
            alt: "Picture of a Fancy Marble Table with Serveware",
            height: 369
        }
    });
    var _optimizeImageUrl, _optimizeImageUrl1;
    return /*#__PURE__*/ _jsx(VanillaBackground, {
        children: /*#__PURE__*/ _jsx(ContentContainer, {
            children: isTabletAndBelow ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(ImageContainer, {
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: (_optimizeImageUrl = optimizeImageUrl({
                                url: image.src
                            }, isSSR, {
                                height: image.height
                            })) !== null && _optimizeImageUrl !== void 0 ? _optimizeImageUrl : EAEAEA_PIXEL,
                            alt: image.alt,
                            height: image.height
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "8x"
                    }),
                    /*#__PURE__*/ _jsx(ContactInfo, {}),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "8x",
                            tabletAndAbove: "7x"
                        }
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "10x"
                    }),
                    /*#__PURE__*/ _jsxs(Row, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ _jsx(SlideIn, {
                                offset: "60px",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: (_optimizeImageUrl1 = optimizeImageUrl({
                                        url: image.src
                                    }, isSSR, {
                                        height: image.height
                                    })) !== null && _optimizeImageUrl1 !== void 0 ? _optimizeImageUrl1 : EAEAEA_PIXEL,
                                    alt: image.alt,
                                    height: image.height
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: 144
                            }),
                            /*#__PURE__*/ _jsx(ContactInfo, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "10x"
                    })
                ]
            })
        })
    });
};
export var ContactModule = observer(ContactModuleBase);
var ContactInfo = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(SlideIn, {
                offset: "60px",
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "displaySSerifRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "UDFeSO",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Contact Us"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsxs(SlideIn, {
                offset: "70px",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: "Faire Wholesale B.V."
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: "Wilhelmina van Pruisenweg 35, 2595AN 's-Gravenhage"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: "+1 1 (800) 208 - 8926"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "YXyPfU",
                            defaultMessage: [
                                {
                                    type: 8,
                                    value: "ContactFormLinkFormatting",
                                    children: [
                                        {
                                            type: 0,
                                            value: "Contact form"
                                        }
                                    ]
                                }
                            ],
                            values: {
                                ContactFormLinkFormatting: ContactFormLinkFormatting
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "Fqau+K",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Netherlands company registration 82541086"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "z1yftA",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "VAT identification number: Dutch VAT number NL862511550B01"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "+v+WGr",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Authorised representative: Chris Sander"
                                }
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var ImageContainer = styled(Row).withConfig({
    componentId: "sc-d683a22e-0"
})([
    "",
    "{margin:0 -",
    ";}",
    "{margin:0 -",
    ";}"
], responsiveMediaQueries.mobile, MOBILE_PADDING, responsiveMediaQueries.tablet, TABLET_PADDING);
var Image = styled.img.withConfig({
    componentId: "sc-d683a22e-1"
})([
    "display:block;width:100%;object-fit:cover;",
    "{width:528px;}"
], responsiveMediaQueries.desktopAndAbove);
